"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealTimeGeocodingEvents = void 0;
var RealTimeGeocodingEvents;
(function (RealTimeGeocodingEvents) {
    RealTimeGeocodingEvents["GEOCODING_CHANGED"] = "geocoding status changed";
})(RealTimeGeocodingEvents = exports.RealTimeGeocodingEvents || (exports.RealTimeGeocodingEvents = {}));
//# sourceMappingURL=Geocoding.consts.js.map